export default __webpack_public_path__ + "static/pexels-mart-production-8458830_-3b545478616689310e77a1979dc114a9.jpg";